import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: ({ loadAtTop }) => (loadAtTop ? '0' : 'unset'),
    bottom: ({ loadAtTop }) => (loadAtTop ? 'unset' : '0'),
    left: '50%',
    padding: '0 !important',
    transform: 'translateX(-50%)'
  },

  spinner: {
    position: 'relative',
    top: '0',
    left: '0'
  }
}))

export default useStyles
